// tslint:disable

import * as Cookie from 'js-cookie';
import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { InputField } from '../../components/fields/input.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { WysiwygField } from '../../components/fields/wysiwyg.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class AtasTraining extends React.Component<any, any> {

    public state: any = {companySiteSpecId: null, companyId: null};
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {

        form.fields.company.registerField();

        if (this.state.companyId) {
            form.fields.company.setValue(this.state.companyId);
        }

        if (this.props.CONFIG.company) {
            form.fields.company.setValue(this.props.CONFIG.company);
        }

        this.executor.updateEndPoint('company-article');
        this.executor.updateForm(form);
        await this.executor.exec('atas-training');
    }


    componentDidMount() {
        try {
            const site = JSON.parse(Cookie.get('site') as string);
            const company = get(site.company, '@id');
            this.setState({
                companyId: company
            });
        }
        catch (err) {
            // console.log(err);
        }
    }

    render() {
        return (
            <ResourceLoader entity="company-article" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div className="col-md-9 realtive col-xs-12">
                    <LoaderComponent isLoading$={this.executor.loading$}/>
                    <ToggleBoxComponent title={this.props.IS_CREATE ? 'Create new Training to the ATAS' : 'Edit training'} color='green' alwaysOpen={true}>
                        <div className="row">
                            <div className='col-xs-12'>
                                <InputField
                                    field={form.fields.title}
                                    validators={[
                                        Validators.required('Required')
                                    ]}/>

                                <InputField
                                    field={form.fields.link}/>

                                <InputField type='number'
                                            field={form.fields.sortNo}/>

                                <WysiwygField
                                    title='Body'
                                    field={form.fields.body}
                                />

                                <CheckboxField
                                    field={form.fields.featured}
                                />

                                <button className='btn btn-primary pull-left' onClick={() => this.saveForm(form)}>Save</button>
                            </div>
                        </div>
                    </ToggleBoxComponent>
                </div>
                <div className="col-md-3 realtive col-xs-12">
                    <ToggleBoxComponent title="Cover">
                        <MediaItemField field={form.fields.cover}/>
                    </ToggleBoxComponent>
                </div>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/atas.training.tsx